import { createSlice } from "@reduxjs/toolkit";
import { EXTRACT_TEXT_VIEW } from "../constants/Constants";

const initialState = {
    extractTextInprogress: EXTRACT_TEXT_VIEW.OFF_VIEW,
    fetchedOCRText: false,
    openCopyTextModal: false,
    ocrCopyText: false,
    enableCropButton: false,
    downloadImageFailed: false, // for OCR and MArk up
    showOrientationModal: false, // for OCR and MArk up
    customToastInstanceArray: [],
};

const extractTextSlice = createSlice({
    name: "extractText",
    initialState,
    reducers: {
        setExtractTextInprogress(state, action) {
            state.extractTextInprogress = action.payload;
        },
        setFetchedOCRText(state, action) {
            state.fetchedOCRText = action.payload;
        },
        setOcrCopyText(state, action) {
            state.ocrCopyText = action.payload;
        },
        setOpenCopyTextModal(state, action) {
            state.openCopyTextModal = action.payload;
        },
        setEnableCropButton(state, action) {
            state.enableCropButton = action.payload;
        },
        setDownloadImageFailed(state, action) {
            state.downloadImageFailed = action.payload;
        },
        setShowOrientationModal(state, action) {
            state.showOrientationModal = action.payload;
        },
        addEditCustomToastInstanceArray(state, action) {
            const { id, message, isLoading, showCloseIcon } = action.payload;
            let customToastArray = state.customToastInstanceArray;
            const index = customToastArray.findIndex((item) => item.id === id);
            if (index !== -1) {
                // If ID exists, update the message at the found index
                const updatedToast = {
                    ...customToastArray[index], // Copy existing properties
                    message: message, // Update message
                    isLoading: isLoading, // Update isLoading
                    showCloseIcon: showCloseIcon, // by default it is false
                };
                customToastArray = [...customToastArray.slice(0, index), updatedToast, ...customToastArray.slice(index + 1)];
            } else {
                customToastArray = [...customToastArray, { id, message: message, isLoading: isLoading, showCloseIcon: showCloseIcon }];
            }
            state.customToastInstanceArray = customToastArray;
        },
        removeCustomToastInstanceArray(state, action) {
            const toastToRemoveId = action.payload;
            let customToastArray = state.customToastInstanceArray;
            customToastArray = customToastArray.filter((obj) => obj.id !== toastToRemoveId);
            state.customToastInstanceArray = customToastArray;
        },
        resetExtractTextReducer() {
            return initialState;
        },
    },
});

export const {
    setExtractTextInprogress,
    resetExtractTextReducer,
    setFetchedOCRText,
    setOcrCopyText,
    setOpenCopyTextModal,
    setEnableCropButton,
    setDownloadImageFailed,
    setShowOrientationModal,
    addEditCustomToastInstanceArray,
    removeCustomToastInstanceArray,
} = extractTextSlice.actions;
export default extractTextSlice.reducer;
